import { useEffect, useState } from "react"
import ApiContext from "src/provider/API/call-service"
import { 
    SidePopupContainer, FlexColumn, Button, 
    Form, FormGroup, FlexRow, AppSpan, AppText 
} from "src/style"
import { RiCloseFill } from "react-icons/ri"
import { useContext } from "react"

export const IntegrationRequest: React.FC<any> = ({product, isDemoRequest, close}) => {
    const {API} = useContext(ApiContext)
    const [input, setInput] = useState({name: '', phoneNumber: '', email: '', message: ''})

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleSubmit (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        const response = await API.requestForProduct({...input, productId: product.id})
        if (response) close()
    }

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="center-popup-container"
                justifyContent="flex-start"
                alignItems="flex-start" 
            >
                <FlexRow justifyContent='space-between' gap='2'>
                    <AppSpan color='#101828' textSize='1.8' fontWeight="600">{isDemoRequest ? 'Request demo' : 'Request early access'}</AppSpan>
                    <Button 
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#000000'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{fontSize: '2.3rem'}} />
                    </Button> 
                </FlexRow>
                <AppText fontWeight="300">
                    Please fill the form below, a representative will reach out to you shortly to schedule a demo session.
                </AppText>
                <Form onSubmit={handleSubmit} topMargin='2'>
                    <FormGroup>
                        <label>Full name</label>
                        <input 
                            placeholder="Enter full name" 
                            name='name'
                            value={input.name}
                            onChange={handleInput}
                            required
                        />
                    </FormGroup>  
                    <FormGroup>
                        <label>Phone number</label>
                        <input 
                            placeholder="Enter phone number" 
                            name='phoneNumber'
                            value={input.phoneNumber}
                            onChange={handleInput}
                            required
                        />
                    </FormGroup>  
                    <FormGroup>
                        <label>Email</label>
                        <input 
                            placeholder="Enter email" 
                            name='email'
                            value={input.email}
                            onChange={handleInput}
                            required
                        />
                    </FormGroup>  
                    <FormGroup>
                        <label>Message</label>
                        <textarea 
                            placeholder="Enter message" 
                            name='message'
                            value={input.message}
                            onChange={handleInput}
                        />
                    </FormGroup>  
                    
                    <FlexRow justifyContent='flex-end' gap='1' topMargin="2">
                        <Button 
                            width='6.7' height='4' bgColor="#ffffff"
                            borderColor='#D0D5DD' 
                            hoverBgColor='#ffffff' color="#344054"
                            hoverColor='#0D968F' titleSize='1.4'
                            onClick={close}
                        >
                            Back
                        </Button>
                        <Button
                            width='8.1'
                            titleSize='1.4' fontWeight="500"
                            height='4' radius='0.8'
                            hoverColor='#0D968F'
                            hoverBgColor='#fff' borderColor='#0D968F'
                        >
                            Submit
                        </Button>
                    </FlexRow>
                </Form>
            </FlexColumn>
        </>
    )
}